import ActionsForm from '@/shared/mixins/actionsForm'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import headerTemplate from './components/headerTemplate/headerTemplate.vue'
import newHeader from './components/newHeader/newHeader.vue'
import newSignature from './components/newSignature/newSignature.vue'
import newGuidance from './components/newGuidance/newGuidance.vue'
import signatureTemplate from './components/signatureTemplate/signatureTemplate.vue'
import guidanceTemplate from './components/guidanceTemplate/guidanceTemplate.vue'
import logTemplateQma from './components/logTemplateQma/logTemplateQma.vue'
import prerequisiteTemplate from './components/prerequisiteTemplate/prerequisiteTemplate.vue'
import equipmentTemplate from './components/equipmentTemplate/equipmentTemplate.vue'
import returnGridTemplate from './components/TemplateDetail/returnGridTemplate/returnGridTemplate.vue'
import templateDetail from './components/TemplateDetail/templateDetail.vue'
import deleteQuestion from '../tabsTemplate/components/TemplateDetail/deleteQuestion/deleteQuestion.vue'
import qmaTemplate from '@/shared/http/repositories/business/qmaTemplate'
import { toast, loading } from '@/shared/utils/UIHelper'

export default {
  name: 'tabsTemplate',
  props: ['templateid', 'tipoTemplate'],
  components: {HeadDetailsGama, headerTemplate, newHeader, newSignature, newGuidance, guidanceTemplate, logTemplateQma, prerequisiteTemplate, equipmentTemplate, templateDetail, returnGridTemplate, signatureTemplate, deleteQuestion},
  mixins: [ActionsForm],
  data () {
    return {
      tabs: 0,
      tabIndex: 0,
      newItensCabecalho: {
        Itens: []
      },
      editarNivelPrioridadeCabecalho: [],
      EditaOrientacaoNivelPrioridade: [],
      EditaEquipamentoNivelPrioridade: [],
      editarItensTableOrientacao: [],
      newItensAssinatura: [],
      isDisabledOrientacao: true,
      isDisabledCabecalho: true,
      isDisabledAssinatura: true,
      editarEtapaTemplateDetalhes: [],
      editarSubEtapaTemplateDetalhes: [],
      newItensOrientacao: [],
      newItenAtivacaosCabecalho: [],
      newItenInativacaosCabecalho: [],
      newItenAtivacaoAssinatura: [],
      newItenInativacaoAssinatura: [],
      newItenAtivacaoOrientacao: [],
      newItenInativacaoOrientacao: [],
      novosItensTableCabecalho: [],
      novosItensTableAssinatura: [],
      novosItensTableOrientacao: [],
      novasSubEtapasEquipamentoSemNovasEtapas: [],
      novasSubEtapasTemplateSemNovasEtapas: [],
      excluirSubEtapasEtapasEquipamentos: [],
      novaPerguntasEtapasSubEtapaCriada: [],
      excluirSubEtapasEtapasTemplate: [],
      ButonEdicaoExclusao: false,
      ResultTemplateQMA: null,
      novaPerguntaPreRequisitoTemplate: [],
      editarPerguntaPreRequisitoTemplate: [],
      editarNivelPrioridadeAssinatura: [],
      editarPerguntaTemplateTemplate: [],
      editarPerguntaEquipamentoTemplate: [],
      excluirPerguntaPreRequisito: [],
      excluirPerguntaTemplatDetalhe: [],
      addEtapaEquipamento: [],
      addEtapaTemplateDetalhes: [],
      novaPerguntasEtapasSubEtapaCriadaTemplate: [],
      semEtapaPrequisito: false,
      voltaGrupoTab: false,
      exclusaoPerguntasEquipamentoPIT: [],
      perguntasImagensTemplate: [],
      editarPerguntasImagens: [],
      orientacaopropsexclusao: false,
      cabecalhopropsexclusao: false,
      assinaturapropsexclusao: false,
      exclusoesItemCabecalho: [],
      statusTemplate: null,
      duplicarCodigo: null,
      duplicarPES: null,
      pesTemplate: null
    }
  },
  watch: {
    templateid () {
      this.carregarStatusTemplate()
    }
  },
  computed: {
  },
  mounted () {
    this.carregarStatusTemplate()
  },
  methods: {
    // 2026-05-29: salvar/publicar separados. Le o status atual pra alternar os botoes PUBLICAR/DESPUBLICAR.
    carregarStatusTemplate () {
      if (!this.templateid) return
      qmaTemplate.GetQMATemplatePainel(this.templateid)
        .then((Response) => {
          this.statusTemplate = Response.data && Response.data.descricaoStatus ? Response.data.descricaoStatus : null
          // ZOP-65: guarda o PES pra ja vir preenchido no modal de duplicar.
          this.pesTemplate = Response.data ? (Response.data.codPes || Response.data.CodPes || null) : null
        })
        .catch(() => {})
    },
    // ZOP-65: duplicar o template sob um codigo novo. O codigo e digitado, como ja e
    // na criacao do zero; o PES vem preenchido com o do original e pode ser trocado.
    abrirDuplicar () {
      this.duplicarCodigo = null
      this.duplicarPES = this.pesTemplate
      this.$refs['modal-duplicar'].show()
    },
    fecharDuplicar () {
      this.$refs['modal-duplicar'].hide()
    },
    confirmarDuplicar () {
      if (!this.duplicarCodigo) return toast.warning('Informe o codigo do novo template')
      loading.push()
      qmaTemplate.DuplicarTemplate({
        templateOrigemId: this.templateid,
        codigoQMATemplate: this.duplicarCodigo,
        pes: this.duplicarPES
      })
        .then((Response) => {
          loading.pop()
          this.fecharDuplicar()
          // Nao navego pro novo template: esta tela e aberta por $emit da listagem,
          // nao por rota com id, entao um $router.push nao remontaria o componente.
          // O toast diz o codigo pra quem duplicou achar na lista.
          const codigo = this.duplicarCodigo
          toast.success(`Template ${codigo} criado como rascunho. Abra pela listagem para editar.`)
        })
        .catch((Error) => {
          loading.pop()
          const msg = (Error.response && Error.response.data) ? Error.response.data : 'Nao foi possivel duplicar o template'
          toast.warning(typeof msg === 'string' ? msg : 'Nao foi possivel duplicar o template')
        })
    },
    publicarTemplate () {
      // Publicar usa o estado ja PERSISTIDO; edicoes em "AG. ENVIO" nao contam. Avisa pra salvar antes.
      if (this.temEdicoesPendentes()) {
        return toast.warning('Você tem alterações não salvas. Clique em SALVAR antes de publicar.')
      }
      loading.push()
      qmaTemplate.PublicarQMATemplate(this.templateid)
        .then(() => {
          loading.pop()
          toast.success('Template publicado')
          this.carregarStatusTemplate()
          this.$emit('atualizaPainel', true)
        })
        .catch((Error) => {
          loading.pop()
          const msg = (Error.response && Error.response.status === 422 && Error.response.data && Error.response.data.message)
            ? Error.response.data.message
            : 'Não foi possível publicar o template'
          toast.warning(msg)
        })
    },
    despublicarTemplate () {
      loading.push()
      qmaTemplate.DespublicarQMATemplate(this.templateid)
        .then(() => {
          loading.pop()
          toast.success('Template despublicado (voltou para rascunho)')
          this.carregarStatusTemplate()
          this.$emit('atualizaPainel', true)
        })
        .catch(() => {
          loading.pop()
          toast.warning('Não foi possível despublicar o template')
        })
    },
    removerExclusao (itemCabecalhoId) {
      this.exclusoesItemCabecalho = this.exclusoesItemCabecalho.filter(e => e !== itemCabecalhoId)
    },
    popUpCabecalho () {
      this.abrirPopUp()
    },
    popUpAssinatura () {
      this.$refs.newAssinatura.popUptAdd()
    },
    popUpOrientacao () {
      this.$refs.newOrientacao.popUptAdd()
    },
    popUpOrientacaoEditar (value) {
      this.$refs.newOrientacao.popUptEditar(value)
    },
    popUpExclusaoItensAguardandoOrientacaoEnvio (value) {
      this.orientacaopropsexclusao = true
      this.cabecalhopropsexclusao = false
      this.$refs.modalExcluir.popUptAdd(value)
    },
    popUpExclusaoItensAguardandoCabecalhoEnvio (value) {
      this.orientacaopropsexclusao = false
      this.cabecalhopropsexclusao = true
      this.$refs.modalExcluir.popUptAdd(value)
    },
    popUpExclusaoItensAguardandoAssinaturaEnvio (value) {
      this.orientacaopropsexclusao = false
      this.cabecalhopropsexclusao = false
      this.assinaturapropsexclusao = true
      this.$refs.modalExcluir.popUptAdd(value)
    },
    voltar () {
      if (this.newItenAtivacaosCabecalho.length > 0 ||
        this.newItenInativacaosCabecalho.length > 0 ||
        this.novaPerguntaPreRequisitoTemplate.length > 0 ||
        this.editarPerguntaPreRequisitoTemplate.length > 0 ||
        this.excluirPerguntaPreRequisito.length > 0 ||
        this.addEtapaEquipamento.length > 0 ||
        this.novasSubEtapasEquipamentoSemNovasEtapas.length > 0 ||
        this.novaPerguntasEtapasSubEtapaCriada.length > 0 ||
        this.exclusaoPerguntasEquipamentoPIT.length > 0 ||
        this.excluirSubEtapasEtapasEquipamentos.length > 0 ||
        this.editarPerguntaEquipamentoTemplate.length > 0 ||
        this.addEtapaTemplateDetalhes.length > 0 ||
        this.novasSubEtapasTemplateSemNovasEtapas.length > 0 ||
        this.novaPerguntasEtapasSubEtapaCriadaTemplate.length > 0 ||
        this.excluirPerguntaTemplatDetalhe.length > 0 ||
        this.excluirSubEtapasEtapasTemplate.length > 0 ||
        this.editarPerguntaTemplateTemplate.length > 0 ||
        this.perguntasImagensTemplate.length > 0 ||
        this.editarPerguntasImagens.length > 0 ||
        this.newItensAssinatura.length > 0 ||
        this.newItenAtivacaoAssinatura.length > 0 ||
        this.newItenInativacaoAssinatura.length > 0 ||
        this.newItensOrientacao.length > 0 ||
        this.newItenInativacaoOrientacao.length > 0 ||
        this.newItenAtivacaoOrientacao.length > 0
      ) {
        this.$refs['confimacao-retornar'].show()
      } else {
        document.location.reload()
      }
    },
    confirmacaoVoltar () {
      this.$refs['confimacao-retornar'].hide()
      document.location.reload()
    },
    cancelarVoltar () {
      this.$refs['confimacao-retornar'].hide()
    },
    abrirPopUpAddNovasEtapasEquipamentos () {
      this.$refs.equipamentoPIT.abrirPopUpAddEtapa()
    },
    abrirPopUpAddNovasEtapasTemplate () {
      this.$refs.template.abrirPopUpAddEtapa()
    },
    voltaGrupo (value) {
      this.voltaGrupoTab = value
    },
    voltarEquipamento () {
      if (this.newItenAtivacaosCabecalho.length > 0 ||
          this.newItenInativacaosCabecalho.length > 0 ||
          this.novaPerguntaPreRequisitoTemplate.length > 0 ||
          this.editarPerguntaPreRequisitoTemplate.length > 0 ||
          this.excluirPerguntaPreRequisito.length > 0 ||
          this.addEtapaEquipamento.length > 0 ||
          this.novasSubEtapasEquipamentoSemNovasEtapas.length > 0 ||
          this.novaPerguntasEtapasSubEtapaCriada.length > 0 ||
          this.exclusaoPerguntasEquipamentoPIT.length > 0 ||
          this.excluirSubEtapasEtapasEquipamentos.length > 0 ||
          this.editarPerguntaEquipamentoTemplate.length > 0 ||
          this.addEtapaTemplateDetalhes.length > 0 ||
          this.novasSubEtapasTemplateSemNovasEtapas.length > 0 ||
          this.novaPerguntasEtapasSubEtapaCriadaTemplate.length > 0 ||
          this.excluirPerguntaTemplatDetalhe.length > 0 ||
          this.excluirSubEtapasEtapasTemplate.length > 0 ||
          this.editarPerguntaTemplateTemplate.length > 0 ||
          this.perguntasImagensTemplate.length > 0 ||
          this.editarPerguntasImagens.length > 0 ||
          this.newItensAssinatura.length > 0 ||
          this.newItenAtivacaoAssinatura.length > 0 ||
          this.newItenInativacaoAssinatura.length > 0 ||
          this.newItensOrientacao.length > 0 ||
          this.newItenInativacaoOrientacao.length > 0 ||
          this.newItenAtivacaoOrientacao.length > 0
      ) {
        this.$refs['confimacao-retornar'].show()
      } else {
        document.location.reload()
      }
    },
    voltarTemplate () {
      if (this.newItenAtivacaosCabecalho.length > 0 ||
          this.newItenInativacaosCabecalho.length > 0 ||
          this.novaPerguntaPreRequisitoTemplate.length > 0 ||
          this.editarPerguntaPreRequisitoTemplate.length > 0 ||
          this.excluirPerguntaPreRequisito.length > 0 ||
          this.addEtapaEquipamento.length > 0 ||
          this.novasSubEtapasEquipamentoSemNovasEtapas.length > 0 ||
          this.novaPerguntasEtapasSubEtapaCriada.length > 0 ||
          this.exclusaoPerguntasEquipamentoPIT.length > 0 ||
          this.excluirSubEtapasEtapasEquipamentos.length > 0 ||
          this.editarPerguntaEquipamentoTemplate.length > 0 ||
          this.addEtapaTemplateDetalhes.length > 0 ||
          this.novasSubEtapasTemplateSemNovasEtapas.length > 0 ||
          this.novaPerguntasEtapasSubEtapaCriadaTemplate.length > 0 ||
          this.excluirPerguntaTemplatDetalhe.length > 0 ||
          this.excluirSubEtapasEtapasTemplate.length > 0 ||
          this.editarPerguntaTemplateTemplate.length > 0 ||
          this.perguntasImagensTemplate.length > 0 ||
          this.editarPerguntasImagens.length > 0 ||
          this.newItensAssinatura.length > 0 ||
          this.newItenAtivacaoAssinatura.length > 0 ||
          this.newItenInativacaoAssinatura.length > 0 ||
          this.newItensOrientacao.length > 0 ||
          this.newItenInativacaoOrientacao.length > 0 ||
          this.newItenAtivacaoOrientacao.length > 0
      ) {
        this.$refs['confimacao-retornar'].show()
      } else {
        document.location.reload()
      }
    },
    abrirPopUp () {
      this.$refs.newCabecalho.popUptAdd()
    },
    abrirPopUpPreRequisito () {
      this.$refs.preRequisito.popUpAddRequisito()
    },
    abrirPopUpExcluirPreRequisito () {
      this.$refs.preRequisito.popUpExcluirRequisito()
    },
    abrirPopUpExcluirEquipamento () {
      this.$refs.equipamentoPIT.popUpExcluirEquipamento()
    },
    abrirPopUpExcluirTemplate () {
      this.$refs.template.popUpExcluirTemplate()
    },
    liberaButonEdicaoExclusao (value) {
      this.ButonEdicaoExclusao = value
    },
    AdicionarTableCabecalho (value) {
      this.novosItensTableCabecalho = value
    },
    AdicionarTableAssinatura (value) {
      this.novosItensTableAssinatura = value
    },
    AdicionarTableOrientacao (value) {
      this.novosItensTableOrientacao = value
    },
    AlteracaoOrientacao (value) {
      this.editarItensTableOrientacao = value
    },
    removerDaTableEdicoes () {
      if (this.ButonEdicaoExclusao === true) {
        var itensAtivacaoInativacao = false
        this.novosItensTableAssinatura = []
        this.$refs.tableCabecalho.removerItemTable()
        this.$refs.tableCabecalho.removerEdicoesInativacaoTable()
        this.$refs.tableCabecalho.removerEdicoesAtivacaoTable()
        itensAtivacaoInativacao = this.$refs.tableCabecalho.removerEdicoesInativacaoAtivacaoRetonarCasoTenhaItemEdicaoTable() === undefined ? false : this.$refs.tableCabecalho.removerEdicoesInativacaoAtivacaoRetonarCasoTenhaItemEdicaoTable()
        if (itensAtivacaoInativacao === false) {
          this.isDisabledCabecalho = true
        }
      } else {
        toast.warning('Selecione pelo menos um item do cabeçalho!')
      }
    },
    removerAssinaturaDaTableEdicoes () {
      var ativacaoInativacaoItens = false
      if (this.ButonEdicaoExclusao === true) {
        this.$refs.assinatura.removerItemTable()
        this.$refs.assinatura.removerEdicoesInativacaoTable()
        this.$refs.assinatura.removerEdicoesAtivacaoTable()
        ativacaoInativacaoItens = this.$refs.assinatura.removerEdicoesInativacaoAtivacaoRetonarCasoTenhaItemEdicaoTable() === undefined ? false : this.$refs.assinatura.removerEdicoesInativacaoAtivacaoRetonarCasoTenhaItemEdicaoTable()
        if (ativacaoInativacaoItens === false) {
          this.isDisabledAssinatura = true
        }
      } else {
        toast.warning('Selecione pelo menos uma assinatura!')
      }
    },
    removerOrientacaoDaTableEdicoes () {
      if (this.ButonEdicaoExclusao === true) {
        this.$refs.orientacao.removerItemTable()
        if (this.removerOrientacaoDaTableEdicoes.length === 0) {
          this.isDisabledOrientacao = true
        }
      } else {
        toast.warning('Selecione pelo menos uma assinatura!')
      }
    },
    semEtapaPreRequisito (value) {
      this.semEtapaPrequisito = value
    },
    salvarNovosItensCabecalho (value) {
      if (this.newItensCabecalho !== null && this.newItensCabecalho !== undefined) {
        for (let i = 0; i < value.item.length; i++) {
          this.isDisabledCabecalho = false
          this.newItensCabecalho.Itens.push(value.item[i])
        }
      } else {
        this.isDisabledCabecalho = false
        this.newItensCabecalho = value
      }
    },
    salvarNovosItensAssinatura (value) {
      if (this.newItensAssinatura !== null && this.newItensAssinatura !== undefined) {
        for (let i = 0; i < value.item.length; i++) {
          this.isDisabledAssinatura = false
          this.newItensAssinatura.push(value.item[i])
        }
      } else {
        this.isDisabledAssinatura = false
        this.newItensAssinatura = value.item
      }
    },
    salvarNovosItensOrientacao (value) {
      if (this.newItensOrientacao !== null && this.newItensOrientacao !== undefined) {
        this.isDisabledOrientacao = false
        this.newItensOrientacao.push(value)
      } else {
        this.isDisabledOrientacao = false
        this.newItensOrientacao = value
      }
    },
    EditaOrientacao (value) {
      if (this.EditaOrientacaoNivelPrioridade !== null && this.EditaOrientacaoNivelPrioridade !== undefined && this.EditaOrientacaoNivelPrioridade.length > 0) {
        this.EditaOrientacaoNivelPrioridade.push(value)
      } else {
        this.EditaOrientacaoNivelPrioridade[0] = value
      }
    },
    removerdeleteOrientacao (value) {
      if (this.EditaOrientacaoNivelPrioridade !== null && this.EditaOrientacaoNivelPrioridade !== undefined && this.EditaOrientacaoNivelPrioridade.length > 0) {
        for (let e = 0; e < this.EditaOrientacaoNivelPrioridade.length; e++) {
          if (this.EditaOrientacaoNivelPrioridade[e].templateOrientacaoId === value) {
            this.EditaOrientacaoNivelPrioridade.splice(e, 1)
            e--
            break
          }
        }
      }
    },
    editaSubEtapaEquipamento (value) {
      if (this.EditaEquipamentoNivelPrioridade !== null && this.EditaEquipamentoNivelPrioridade !== undefined && this.EditaEquipamentoNivelPrioridade.length > 0) {
        this.EditaEquipamentoNivelPrioridade.push(value)
      } else {
        this.EditaEquipamentoNivelPrioridade[0] = value
      }
    },
    addEdicaoAtivacao (value) {
      if (this.newItenAtivacaosCabecalho !== null && this.newItenAtivacaosCabecalho !== undefined && this.newItenAtivacaosCabecalho.length > 0) {
        this.newItenAtivacaosCabecalho.push(value)
        this.isDisabledCabecalho = false
      } else {
        this.isDisabledCabecalho = false
        this.newItenAtivacaosCabecalho[0] = value
      }
    },
    addEdicaoInativacao (id, exclusao) {
      if (this.newItenInativacaosCabecalho !== null && this.newItenInativacaosCabecalho !== undefined && this.newItenInativacaosCabecalho.length > 0) {
        this.newItenInativacaosCabecalho.push(id)
        this.isDisabledCabecalho = false
      } else {
        this.isDisabledCabecalho = false
        this.newItenInativacaosCabecalho[0] = id
      }

      if (exclusao) {
        this.exclusoesItemCabecalho.push(id)
      }
    },
    addEdicaoAtivacaoAssinatura (value) {
      if (this.newItenAtivacaoAssinatura !== null && this.newItenAtivacaoAssinatura !== undefined && this.newItenAtivacaoAssinatura.length > 0) {
        this.isDisabledAssinatura = false
        this.newItenAtivacaoAssinatura.push(value)
      } else {
        this.isDisabledAssinatura = false
        this.newItenAtivacaoAssinatura[0] = value
      }
    },
    addEdicaoAtivacaoOrientacao (value) {
      if (this.newItenAtivacaoOrientacao !== null && this.newItenAtivacaoOrientacao !== undefined && this.newItenAtivacaoOrientacao.length > 0) {
        this.newItenAtivacaoOrientacao.push(value)
      } else {
        this.newItenAtivacaoOrientacao[0] = value
      }
    },
    addEdicaoInativacaoAssinatura (value) {
      if (this.newItenInativacaoAssinatura !== null && this.newItenInativacaoAssinatura !== undefined && this.newItenInativacaoAssinatura.length > 0) {
        this.isDisabledAssinatura = false
        this.newItenInativacaoAssinatura.push(value)
      } else {
        this.isDisabledAssinatura = false
        this.newItenInativacaoAssinatura[0] = value
      }
    },
    addEdicaoInativacaoOrientacao (value) {
      if (this.newItenInativacaoOrientacao !== null && this.newItenInativacaoOrientacao !== undefined && this.newItenInativacaoOrientacao.length > 0) {
        this.newItenInativacaoOrientacao.push(value)
      } else {
        this.newItenInativacaoOrientacao[0] = value
      }
    },
    addNovaEtapa (value) {
      if (this.addEtapaEquipamento !== null && this.addEtapaEquipamento !== undefined && this.addEtapaEquipamento.length > 0) {
        this.addEtapaEquipamento.push(value)
      } else {
        this.addEtapaEquipamento[0] = value
      }
    },
    addNovaPerguntaEtapaSubCriada (value) {
      if (this.novaPerguntasEtapasSubEtapaCriada !== null && this.novaPerguntasEtapasSubEtapaCriada !== undefined && this.novaPerguntasEtapasSubEtapaCriada.length > 0) {
        this.novaPerguntasEtapasSubEtapaCriada.push(value)
      } else {
        this.novaPerguntasEtapasSubEtapaCriada[0] = value
      }
    },
    editarEmMemoriaNovaPerguntaEtapaSubCriada (value) {
      if (this.novaPerguntasEtapasSubEtapaCriada !== null && this.novaPerguntasEtapasSubEtapaCriada !== undefined && this.novaPerguntasEtapasSubEtapaCriada.length > 0) {
        for (let e = 0; e < this.novaPerguntasEtapasSubEtapaCriada.length; e++) {
          if (this.novaPerguntasEtapasSubEtapaCriada[e].perguntaId === value.perguntaId) {
            this.novaPerguntasEtapasSubEtapaCriada[e].pergunta = value.pergunta
            this.novaPerguntasEtapasSubEtapaCriada[e].tipoCampo = value.tipoCampo
          }
        }
      }
    },
    addNovaSubEtapaObjEtapaNova (value) {
      if (this.addEtapaEquipamento !== null && this.addEtapaEquipamento !== undefined && this.addEtapaEquipamento.length > 0) {
        for (let e = 0; e < this.addEtapaEquipamento.length; e++) {
          if (this.addEtapaEquipamento[e].etapaId === value.etapaId) {
            this.addEtapaEquipamento[e].subEtapa.push(value)
          }
        }
      }
    },
    removerSubEtapaAgEnvioEtapa (value) {
      if (this.addEtapaEquipamento !== null && this.addEtapaEquipamento !== undefined && this.addEtapaEquipamento.length > 0) {
        for (let e = 0; e < this.addEtapaEquipamento.length; e++) {
          if (this.addEtapaEquipamento[e].etapaId === value.etapaId) {
            for (let s = 0; s < this.addEtapaEquipamento[e].subEtapa.length; e++) {
              if (this.addEtapaEquipamento[e].subEtapa[s].subEtapaId === value.subEtapaId) {
                this.addEtapaEquipamento[e].subEtapa.splice(s, 1)
                s--
                break
              }
            }
          }
        }
      }
    },
    removerEtapaEstatica (value) {
      if (this.addEtapaTemplateDetalhes !== null && this.addEtapaTemplateDetalhes !== undefined && this.addEtapaTemplateDetalhes.length > 0) {
        for (let e = 0; e < this.addEtapaTemplateDetalhes.length; e++) {
          if (this.addEtapaTemplateDetalhes[e].etapaId === value) {
            this.addEtapaTemplateDetalhes.splice(e, 1)
            e--
            break
          }
        }
      }
    },
    removerEtapaEquipamentoEstatica (value) {
      if (this.addEtapaEquipamento !== null && this.addEtapaEquipamento !== undefined && this.addEtapaEquipamento.length > 0) {
        for (let e = 0; e < this.addEtapaEquipamento.length; e++) {
          if (this.addEtapaEquipamento[e].etapaId === value) {
            this.addEtapaEquipamento.splice(e, 1)
            e--
            break
          }
        }
      }
    },
    addNovaPerguntaObjEtapaNova (value) {
      if (this.addEtapaEquipamento !== null && this.addEtapaEquipamento !== undefined && this.addEtapaEquipamento.length > 0) {
        for (let e = 0; e < this.addEtapaEquipamento.length; e++) {
          if (this.addEtapaEquipamento[e].etapaId === value.etapaId) {
            for (let j = 0; j < this.addEtapaEquipamento[e].subEtapa.length; j++) {
              if (this.addEtapaEquipamento[e].subEtapa[j].subEtapaId === value.subEtapas[0].subEtapaId) {
                this.addEtapaEquipamento[e].subEtapa[j].itens.push(value.subEtapas[0].itens[0])
                break // Para o loop após encontrar a subetapa correta
              }
            }
            break // Para o loop da etapa ao encontrar a correta
          }
        }
      }
    },
    editarEmMemoriaNovaPerguntaParaEtapa (value) {
      if (this.addEtapaEquipamento !== null && this.addEtapaEquipamento !== undefined && this.addEtapaEquipamento.length > 0) {
        for (let e = 0; e < this.addEtapaEquipamento.length; e++) {
          if (this.addEtapaEquipamento[e].etapaId === value.etapaId) {
            for (let s = 0; s < this.addEtapaEquipamento[e].subEtapa.length; s++) {
              if (this.addEtapaEquipamento[e].subEtapa[s].subEtapaId === value.subEtapaId) {
                for (let p = 0; p < this.addEtapaEquipamento[e].subEtapa[s].itens.length; p++) {
                  if (this.addEtapaEquipamento[e].subEtapa[s].itens[p].perguntaId === value.perguntaId) {
                    this.addEtapaEquipamento[e].subEtapa[s].itens[p].pergunta = value.pergunta
                    this.addEtapaEquipamento[e].subEtapa[s].itens[p].tipoCampo = value.tipoCampo
                    this.addEtapaEquipamento[e].subEtapa[s].itens[p].multiplos = value.multiplos
                  }
                }
              }
            }
          }
        }
      }
    },
    NovaPerguntaPreRequisito (value) {
      if (this.novaPerguntaPreRequisitoTemplate !== null && this.novaPerguntaPreRequisitoTemplate !== undefined && this.novaPerguntaPreRequisitoTemplate.length > 0) {
        this.novaPerguntaPreRequisitoTemplate.push(value)
      } else {
        this.novaPerguntaPreRequisitoTemplate[0] = value
      }
    },
    ExcluirPerguntaEquipamento (value) {
      if (this.exclusaoPerguntasEquipamentoPIT !== null && this.exclusaoPerguntasEquipamentoPIT !== undefined && this.exclusaoPerguntasEquipamentoPIT.length > 0) {
        this.exclusaoPerguntasEquipamentoPIT.push(value)
      } else {
        this.exclusaoPerguntasEquipamentoPIT[0] = value
      }
    },
    ExcluirSubEtapasEtapas (value) {
      if (this.excluirSubEtapasEtapasEquipamentos !== null && this.excluirSubEtapasEtapasEquipamentos !== undefined && this.excluirSubEtapasEtapasEquipamentos.length > 0) {
        this.excluirSubEtapasEtapasEquipamentos.push(value)
      } else {
        this.excluirSubEtapasEtapasEquipamentos[0] = value
      }
    },
    addNovaSubEtapaObjSemNovaEtapa (value) {
      if (this.novasSubEtapasEquipamentoSemNovasEtapas !== null && this.novasSubEtapasEquipamentoSemNovasEtapas !== undefined && this.novasSubEtapasEquipamentoSemNovasEtapas.length > 0) {
        this.novasSubEtapasEquipamentoSemNovasEtapas.push(value)
      } else {
        this.novasSubEtapasEquipamentoSemNovasEtapas[0] = value
      }
    },
    removerSubEtapaEtapaCriada (value) {
      if (this.novasSubEtapasEquipamentoSemNovasEtapas !== null && this.novasSubEtapasEquipamentoSemNovasEtapas !== undefined && this.novasSubEtapasEquipamentoSemNovasEtapas.length > 0) {
        for (let e = 0; e < this.novasSubEtapasEquipamentoSemNovasEtapas.length; e++) {
          if (this.novasSubEtapasEquipamentoSemNovasEtapas[e].subEtapaId === value.subEtapaId) {
            this.novasSubEtapasEquipamentoSemNovasEtapas.splice(e, 1)
            e--
            break
          }
        }
      }
    },
    addNovaPerguntaImagem (value) {
      if (this.perguntasImagensTemplate !== null && this.perguntasImagensTemplate !== undefined && this.perguntasImagensTemplate.length > 0) {
        this.perguntasImagensTemplate.push(value)
      } else {
        this.perguntasImagensTemplate[0] = value
      }
    },
    EditarNovaPerguntaImagem (value) {
      if (this.editarPerguntasImagens !== null && this.editarPerguntasImagens !== undefined && this.editarPerguntasImagens.length > 0) {
        this.editarPerguntasImagens.push(value)
      } else {
        this.editarPerguntasImagens[0] = value
      }
    },
    addNovaPerguntaParaSubEtapa (value) {
      if (this.novasSubEtapasEquipamentoSemNovasEtapas !== null && this.novasSubEtapasEquipamentoSemNovasEtapas !== undefined && this.novasSubEtapasEquipamentoSemNovasEtapas.length > 0) {
        for (let e = 0; e < this.novasSubEtapasEquipamentoSemNovasEtapas.length; e++) {
          if (this.novasSubEtapasEquipamentoSemNovasEtapas[e].subEtapaId === value.subEtapaId) {
            this.novasSubEtapasEquipamentoSemNovasEtapas[e].itens.push(value)
            break // Para o loop da etapa ao encontrar a correta
          }
        }
      }
    },
    addNovaEtapaTemplate (value) {
      if (this.addEtapaTemplateDetalhes !== null && this.addEtapaTemplateDetalhes !== undefined && this.addEtapaTemplateDetalhes.length > 0) {
        this.addEtapaTemplateDetalhes.push(value)
      } else {
        this.addEtapaTemplateDetalhes[0] = value
      }
    },
    editarEtapa (value) {
      if (this.editarEtapaTemplateDetalhes !== null && this.editarEtapaTemplateDetalhes !== undefined && this.editarEtapaTemplateDetalhes.length > 0) {
        this.editarEtapaTemplateDetalhes.push(value)
      } else {
        this.editarEtapaTemplateDetalhes[0] = value
      }
    },
    editaSubEtapa (value) {
      if (this.editarSubEtapaTemplateDetalhes !== null && this.editarSubEtapaTemplateDetalhes !== undefined && this.editarSubEtapaTemplateDetalhes.length > 0) {
        this.editarSubEtapaTemplateDetalhes.push(value)
      } else {
        this.editarSubEtapaTemplateDetalhes[0] = value
      }
    },
    addNovaSubEtapaTemplateObjEtapaNova (value) {
      if (this.addEtapaTemplateDetalhes !== null && this.addEtapaTemplateDetalhes !== undefined && this.addEtapaTemplateDetalhes.length > 0) {
        for (let e = 0; e < this.addEtapaTemplateDetalhes.length; e++) {
          if (this.addEtapaTemplateDetalhes[e].etapaId === value.etapaId) {
            this.addEtapaTemplateDetalhes[e].subEtapa.push(value)
          }
        }
      }
    },
    removerSubEtapaTemplateAgEnvioEtapa (value) {
      if (this.addEtapaTemplateDetalhes !== null && this.addEtapaTemplateDetalhes !== undefined && this.addEtapaTemplateDetalhes.length > 0) {
        for (let e = 0; e < this.addEtapaTemplateDetalhes.length; e++) {
          if (this.addEtapaTemplateDetalhes[e].etapaId === value.etapaId) {
            for (let s = 0; s < this.addEtapaTemplateDetalhes[e].subEtapa.length; e++) {
              if (this.addEtapaTemplateDetalhes[e].subEtapa[s].subEtapaId === value.subEtapaId) {
                this.addEtapaTemplateDetalhes[e].subEtapa.splice(s, 1)
                s--
                break
              }
            }
          }
        }
      }
    },
    ExcluirSubEtapasEtapasTemplateDetalhe (value) {
      if (this.excluirSubEtapasEtapasTemplate !== null && this.excluirSubEtapasEtapasTemplate !== undefined && this.excluirSubEtapasEtapasTemplate.length > 0) {
        this.excluirSubEtapasEtapasTemplate.push(value)
      } else {
        this.excluirSubEtapasEtapasTemplate[0] = value
      }
    },
    removerExclusaoEtapaSubEtapa (value) {
      if (this.excluirSubEtapasEtapasTemplate !== null && this.excluirSubEtapasEtapasTemplate !== undefined && this.excluirSubEtapasEtapasTemplate.length > 0) {
        for (let e = 0; e < this.excluirSubEtapasEtapasTemplate.length; e++) {
          if (this.excluirSubEtapasEtapasTemplate[e].etapaId === value.etapaId) {
            this.excluirSubEtapasEtapasTemplate.splice(e, 1)
            e--
            break
          }
        }
      }
    },
    ExcluirPerguntaTemplate (value) {
      if (this.excluirPerguntaTemplatDetalhe !== null && this.excluirPerguntaTemplatDetalhe !== undefined && this.excluirPerguntaTemplatDetalhe.length > 0) {
        this.excluirPerguntaTemplatDetalhe.push(value)
      } else {
        this.excluirPerguntaTemplatDetalhe[0] = value
      }
    },
    RemoverEdicaoExcluirPerguntaTemplate (value) {
      if (this.excluirPerguntaTemplatDetalhe !== null && this.excluirPerguntaTemplatDetalhe !== undefined && this.excluirPerguntaTemplatDetalhe.length > 0) {
        for (let e = 0; e < this.excluirPerguntaTemplatDetalhe.length; e++) {
          if (this.excluirPerguntaTemplatDetalhe[e].perguntaId === value.perguntaId) {
            this.excluirPerguntaTemplatDetalhe.splice(e, 1)
            e--
            break
          }
        }
      }
    },
    novaEtapaTemplatePergunta (value) {
      if (this.addEtapaTemplateDetalhes !== null && this.addEtapaTemplateDetalhes !== undefined && this.addEtapaTemplateDetalhes.length > 0) {
        for (let e = 0; e < this.addEtapaTemplateDetalhes.length; e++) {
          if (this.addEtapaTemplateDetalhes[e].etapaId === value.etapaId) {
            for (let j = 0; j < this.addEtapaTemplateDetalhes[e].subEtapa.length; j++) {
              if (this.addEtapaTemplateDetalhes[e].subEtapa[j].subEtapaId === value.subEtapas[0].subEtapaId) {
                this.addEtapaTemplateDetalhes[e].subEtapa[j].itens.push(value.subEtapas[0].itens[0])
                break // Para o loop após encontrar a subetapa correta
              }
            }
            break // Para o loop da etapa ao encontrar a correta
          }
        }
      }
    },
    EditaTemplateNovaPergunta (value) {
      if (this.addEtapaTemplateDetalhes !== null && this.addEtapaTemplateDetalhes !== undefined && this.addEtapaTemplateDetalhes.length > 0) {
        for (let e = 0; e < this.addEtapaTemplateDetalhes.length; e++) {
          if (this.addEtapaTemplateDetalhes[e].etapaId === value.grupoId) {
            for (let j = 0; j < this.addEtapaTemplateDetalhes[e].subEtapa.length; j++) {
              if (this.addEtapaTemplateDetalhes[e].subEtapa[j].subEtapaId === value.subEtapaId) {
                for (let p = 0; p < this.addEtapaTemplateDetalhes[e].subEtapa[j].itens.length; p++) {
                  if (this.addEtapaTemplateDetalhes[e].subEtapa[j].itens[p].perguntaId === value.perguntaId) {
                    this.addEtapaTemplateDetalhes[e].subEtapa[j].itens[p].pergunta = value.pergunta
                    this.addEtapaTemplateDetalhes[e].subEtapa[j].itens[p].tipoCampo = value.tipoCampo
                    this.addEtapaTemplateDetalhes[e].subEtapa[j].itens[p].multiplos = value.multiplos
                    this.addEtapaTemplateDetalhes[e].subEtapa[j].itens[p].perguntaSelecao = value.perguntaSelecao
                    this.addEtapaTemplateDetalhes[e].subEtapa[j].itens[p].nivelPrioridadePergunta = value.nivelPrioridadePergunta
                    this.addEtapaTemplateDetalhes[e].subEtapa[j].itens[p].opcional = value.opcional
                  }
                }
              }
            }
          }
        }
      }
    },
    ExcluirPerguntaTemplateDetalheEtapa (value) {
      if (this.addEtapaTemplateDetalhes !== null && this.addEtapaTemplateDetalhes !== undefined && this.addEtapaTemplateDetalhes.length > 0) {
        for (let e = 0; e < this.addEtapaTemplateDetalhes.length; e++) {
          if (this.addEtapaTemplateDetalhes[e].etapaId === value.grupoId) {
            for (let s = 0; s < this.addEtapaTemplateDetalhes[e].subEtapa.length; s++) {
              if (this.addEtapaTemplateDetalhes[e].subEtapa[s].subEtapaId === value.etapaId) {
                for (let p = 0; p < this.addEtapaTemplateDetalhes[e].subEtapa[s].itens.length; p++) {
                  if (this.addEtapaTemplateDetalhes[e].subEtapa[s].itens[p].perguntaId === value.perguntaId) {
                    this.addEtapaTemplateDetalhes[e].subEtapa[s].itens.splice(p, 1)
                    p--
                    break
                  }
                }
              }
            }
          }
        }
      }
    },
    addNovaSubEtapaObjSemNovaEtapaTemplate (value) {
      if (this.novasSubEtapasTemplateSemNovasEtapas !== null && this.novasSubEtapasTemplateSemNovasEtapas !== undefined && this.novasSubEtapasTemplateSemNovasEtapas.length > 0) {
        this.novasSubEtapasTemplateSemNovasEtapas.push(value)
      } else {
        this.novasSubEtapasTemplateSemNovasEtapas[0] = value
      }
    },
    removerSubEtapaEtapaTemplateCriada (value) {
      if (this.novasSubEtapasTemplateSemNovasEtapas !== null && this.novasSubEtapasTemplateSemNovasEtapas !== undefined && this.novasSubEtapasTemplateSemNovasEtapas.length > 0) {
        for (let e = 0; e < this.novasSubEtapasTemplateSemNovasEtapas.length; e++) {
          if (this.novasSubEtapasTemplateSemNovasEtapas[e].subEtapaId === value.subEtapaId) {
            this.novasSubEtapasTemplateSemNovasEtapas.splice(e, 1)
            e--
            break
          }
        }
      }
    },
    addNovaPerguntaParaSubEtapaTemplate (value) {
      if (this.novasSubEtapasTemplateSemNovasEtapas !== null && this.novasSubEtapasTemplateSemNovasEtapas !== undefined && this.novasSubEtapasTemplateSemNovasEtapas.length > 0) {
        for (let e = 0; e < this.novasSubEtapasTemplateSemNovasEtapas.length; e++) {
          if (this.novasSubEtapasTemplateSemNovasEtapas[e].subEtapaId === value.subEtapaId) {
            this.novasSubEtapasTemplateSemNovasEtapas[e].itens.push(value)
            break // Para o loop da etapa ao encontrar a correta
          }
        }
      }
    },
    editarEmMemoriaNovaPerguntaParaSubEtapaTemplate (value) {
      if (this.novasSubEtapasTemplateSemNovasEtapas !== null && this.novasSubEtapasTemplateSemNovasEtapas !== undefined && this.novasSubEtapasTemplateSemNovasEtapas.length > 0) {
        for (let e = 0; e < this.novasSubEtapasTemplateSemNovasEtapas.length; e++) {
          if (this.novasSubEtapasTemplateSemNovasEtapas[e].subEtapaId === value.subEtapaId) {
            for (let p = 0; p < this.novasSubEtapasTemplateSemNovasEtapas[e].itens.length; p++) {
              if (this.novasSubEtapasTemplateSemNovasEtapas[e].itens[p].perguntaId === value.perguntaId) {
                this.novasSubEtapasTemplateSemNovasEtapas[e].itens[p].pergunta = value.pergunta
                this.novasSubEtapasTemplateSemNovasEtapas[e].itens[p].tipoCampo = value.tipoCampo
                this.novasSubEtapasTemplateSemNovasEtapas[e].itens[p].multiplos = value.multiplos
                this.novasSubEtapasTemplateSemNovasEtapas[e].itens[p].perguntaSelecao = value.perguntaSelecao
              }
            }
          }
        }
      }
    },
    ExcluirPerguntaTemplateDetalheSubEtapa (value) {
      if (this.novasSubEtapasTemplateSemNovasEtapas !== null && this.novasSubEtapasTemplateSemNovasEtapas !== undefined && this.novasSubEtapasTemplateSemNovasEtapas.length > 0) {
        for (let e = 0; e < this.novasSubEtapasTemplateSemNovasEtapas.length; e++) {
          if (this.novasSubEtapasTemplateSemNovasEtapas[e].subEtapaId === value.etapaId) {
            for (let s = 0; s < this.novasSubEtapasTemplateSemNovasEtapas[e].itens.length; s++) {
              if (this.novasSubEtapasTemplateSemNovasEtapas[e].itens[s].perguntaId === value.perguntaId) {
                this.novasSubEtapasTemplateSemNovasEtapas[e].itens.splice(s, 1)
                s--
                break
              }
            }
          }
        }
      }
    },
    addNovaPerguntaEtapaSubCriadaTemplate (value) {
      if (this.novaPerguntasEtapasSubEtapaCriadaTemplate !== null && this.novaPerguntasEtapasSubEtapaCriadaTemplate !== undefined && this.novaPerguntasEtapasSubEtapaCriadaTemplate.length > 0) {
        this.novaPerguntasEtapasSubEtapaCriadaTemplate.push(value)
      } else {
        this.novaPerguntasEtapasSubEtapaCriadaTemplate[0] = value
      }
    },

    editarEmMemoriaNovaPerguntaParaEtapaTemplate (value) {
      if (this.novaPerguntasEtapasSubEtapaCriadaTemplate !== null && this.novaPerguntasEtapasSubEtapaCriadaTemplate !== undefined && this.novaPerguntasEtapasSubEtapaCriadaTemplate.length > 0) {
        for (let e = 0; e < this.novaPerguntasEtapasSubEtapaCriadaTemplate.length; e++) {
          if (this.novaPerguntasEtapasSubEtapaCriadaTemplate[e].etapaId === value.etapaId && this.novaPerguntasEtapasSubEtapaCriadaTemplate[e].subEtapaId === value.subEtapaId) {
            if (this.novaPerguntasEtapasSubEtapaCriadaTemplate[e].perguntaId === value.perguntaId) {
              this.novaPerguntasEtapasSubEtapaCriadaTemplate[e].pergunta = value.pergunta
              this.novaPerguntasEtapasSubEtapaCriadaTemplate[e].tipoCampo = value.tipoCampo
              this.novaPerguntasEtapasSubEtapaCriadaTemplate[e].multiplos = value.multiplos
              this.novaPerguntasEtapasSubEtapaCriadaTemplate[e].perguntaSelecao = value.perguntaSelecao
              this.novaPerguntasEtapasSubEtapaCriadaTemplate[e].nivelPrioridadePergunta = value.nivelPrioridadePergunta
            }
          }
        }
      }
    },
    ExcluirPerguntaTemplateDetalheCriado (value) {
      for (let e = 0; e < this.novaPerguntasEtapasSubEtapaCriadaTemplate.length; e++) {
        if (this.novaPerguntasEtapasSubEtapaCriadaTemplate[e].subEtapaId === value.etapaId && this.novaPerguntasEtapasSubEtapaCriadaTemplate[e].perguntaId === value.perguntaId) {
          this.novaPerguntasEtapasSubEtapaCriadaTemplate.splice(e, 1)
          e--
          break
        }
      }
    },
    EditaTemplatePergunta (value) {
      if (this.editarPerguntaTemplateTemplate !== null && this.editarPerguntaTemplateTemplate !== undefined && this.editarPerguntaTemplateTemplate.length > 0) {
        this.editarPerguntaTemplateTemplate.push(value)
      } else {
        this.editarPerguntaTemplateTemplate[0] = value
      }
    },
    editarEmMemoriaNovaPerguntaParaSubEtapa (value) {
      if (this.novasSubEtapasEquipamentoSemNovasEtapas !== null && this.novasSubEtapasEquipamentoSemNovasEtapas !== undefined && this.novasSubEtapasEquipamentoSemNovasEtapas.length > 0) {
        for (let e = 0; e < this.novasSubEtapasEquipamentoSemNovasEtapas.length; e++) {
          if (this.novasSubEtapasEquipamentoSemNovasEtapas[e].subEtapaId === value.subEtapaId) {
            for (let p = 0; p < this.novasSubEtapasEquipamentoSemNovasEtapas[e].itens.length; p++) {
              if (this.novasSubEtapasEquipamentoSemNovasEtapas[e].itens[p].perguntaId === value.perguntaId) {
                this.novasSubEtapasEquipamentoSemNovasEtapas[e].itens[p].pergunta = value.pergunta
                this.novasSubEtapasEquipamentoSemNovasEtapas[e].itens[p].tipoCampo = value.tipoCampo
              }
            }
          }
        }
      }
    },
    EditaPreRequisitoNovaPergunta (value) {
      for (let e = 0; e < this.novaPerguntaPreRequisitoTemplate.length; e++) {
        if (this.novaPerguntaPreRequisitoTemplate[e].etapaId === value.etapaId && this.novaPerguntaPreRequisitoTemplate[e].perguntaId === value.perguntaId) {
          this.novaPerguntaPreRequisitoTemplate[e].pergunta = value.pergunta
          this.novaPerguntaPreRequisitoTemplate[e].nivelPrioridadePergunta = value.nivelPrioridadePergunta
        }
      }
    },
    EditaEquipamentoNovaPergunta (value) {
      for (let e = 0; e < this.novaPerguntaPreRequisitoTemplate.length; e++) {
        if (this.novaPerguntaPreRequisitoTemplate[e].etapaId === value.etapaId && this.novaPerguntaPreRequisitoTemplate[e].perguntaId === value.perguntaId) {
          this.novaPerguntaPreRequisitoTemplate[e].pergunta = value.pergunta
        }
      }
    },
    EditaPreRequisitoPergunta (value) {
      if (this.editarPerguntaPreRequisitoTemplate !== null && this.editarPerguntaPreRequisitoTemplate !== undefined && this.editarPerguntaPreRequisitoTemplate.length > 0) {
        this.editarPerguntaPreRequisitoTemplate.push(value)
      } else {
        this.editarPerguntaPreRequisitoTemplate[0] = value
      }
    },
    EditaEquipamentoPergunta (value) {
      if (this.editarPerguntaEquipamentoTemplate !== null && this.editarPerguntaEquipamentoTemplate !== undefined && this.editarPerguntaEquipamentoTemplate.length > 0) {
        this.editarPerguntaEquipamentoTemplate.push(value)
      } else {
        this.editarPerguntaEquipamentoTemplate[0] = value
      }
    },
    ExcluirNovaPerguntaPreRequisito (value) {
      for (let e = 0; e < this.novaPerguntaPreRequisitoTemplate.length; e++) {
        if (this.novaPerguntaPreRequisitoTemplate[e].etapaId === value.etapaId && this.novaPerguntaPreRequisitoTemplate[e].perguntaId === value.perguntaId) {
          this.novaPerguntaPreRequisitoTemplate.splice(e, 1)
          e--
        }
      }
    },
    ExcluirPerguntaPerguntaEquipamentoCriado (value) {
      for (let e = 0; e < this.novaPerguntasEtapasSubEtapaCriada.length; e++) {
        if (this.novaPerguntasEtapasSubEtapaCriada[e].subEtapaId === value.etapaId && this.novaPerguntasEtapasSubEtapaCriada[e].perguntaId === value.perguntaId) {
          this.novaPerguntasEtapasSubEtapaCriada.splice(e, 1)
          e--
          break
        }
      }
    },

    ExcluirPerguntaPreRequisito (value) {
      if (this.excluirPerguntaPreRequisito !== null && this.excluirPerguntaPreRequisito !== undefined && this.excluirPerguntaPreRequisito.length > 0) {
        this.excluirPerguntaPreRequisito.push(value)
      } else {
        this.excluirPerguntaPreRequisito[0] = value
      }
    },
    RemoverExclusaoPerguntaPreRequisito (value) {
      for (let e = 0; e < this.excluirPerguntaPreRequisito.length; e++) {
        if (this.excluirPerguntaPreRequisito[e].etapaId === value.etapaId && this.excluirPerguntaPreRequisito[e].perguntaId === value.perguntaId) {
          this.excluirPerguntaPreRequisito.splice(e, 1)
          e--
        }
      }
    },
    removerExclusaoEtapaSubEtapaEquipamento (value) {
      for (let e = 0; e < this.excluirSubEtapasEtapasEquipamentos.length; e++) {
        if (this.excluirSubEtapasEtapasEquipamentos[e].etapaId === value.etapaId && this.excluirSubEtapasEtapasEquipamentos[e].subEtapaId === value.subEtapaId) {
          this.excluirSubEtapasEtapasEquipamentos.splice(e, 1)
          e--
        }
      }
    },
    removerItensparaEdicaoExclusao (value) {
      for (let i = 0; i < value.length; i++) {
        // Encontra o índice do objeto a ser removido
        for (let j = 0; j < this.newItensCabecalho.Itens.length; j++) {
          if (this.newItensCabecalho.Itens[j] === value[i]) {
            if (this.newItensCabecalho.Itens.length > 1) {
              this.newItensCabecalho.Itens.splice(j, 1)
            } else {
              this.newItensCabecalho = {}
            }
            break
          }
        }
      }
    },
    removerItensparaEdicaoAtivacaoExclusao (value) {
      for (let i = 0; i < value.length; i++) {
        // Encontra o índice do objeto a ser removido
        for (let j = 0; j < this.newItenAtivacaoAssinatura.length; j++) {
          if (this.newItenAtivacaoAssinatura[j] === value[i]) {
            this.newItenAtivacaoAssinatura.splice(j, 1)
            break
          }
        }
      }
    },
    removerItensparaEdicaoAtivacaoAssinaturaExclusao (value) {
      for (let i = 0; i < value.length; i++) {
        // Encontra o índice do objeto a ser removido
        for (let j = 0; j < this.newItenAtivacaoAssinatura.length; j++) {
          if (this.newItenAtivacaoAssinatura[j] === value[i]) {
            this.newItenAtivacaoAssinatura.splice(j, 1)
            j--
            break
          }
        }
      }
    },
    removerItensparaEdicaoInativacaoAssinaturaExclusao (value) {
      for (let i = 0; i < value.length; i++) {
        // Encontra o índice do objeto a ser removido
        for (let j = 0; j < this.newItenInativacaoAssinatura.length; j++) {
          if (this.newItenInativacaoAssinatura[j] === value[i]) {
            this.newItenInativacaoAssinatura.splice(j, 1)
            j--
            break
          }
        }
      }
    },
    removerItensparaEdicaoAtivacaoOrientacaoExclusao (value) {
      for (let i = 0; i < value.length; i++) {
        // Encontra o índice do objeto a ser removido
        for (let j = 0; j < this.newItenAtivacaoOrientacao.length; j++) {
          if (this.newItenAtivacaoOrientacao[j] === value[i]) {
            this.newItenAtivacaoOrientacao.splice(j, 1)
            j--
            break
          }
        }
      }
    },
    removerItensparaEdicaoInativacaoOrientacaoExclusao (value) {
      for (let i = 0; i < value.length; i++) {
        // Encontra o índice do objeto a ser removido
        for (let j = 0; j < this.newItenInativacaoOrientacao.length; j++) {
          if (this.newItenInativacaoOrientacao[j] === value[i]) {
            this.newItenInativacaoOrientacao.splice(j, 1)
            j--
            break
          }
        }
      }
    },
    removerItensparaEdicaoInativacaoExclusao (value) {
      for (let i = 0; i < value.length; i++) {
        // Encontra o índice do objeto a ser removido
        for (let j = 0; j < this.newItenInativacaosCabecalho.length; j++) {
          if (this.newItenInativacaosCabecalho[j] === value[i]) {
            this.newItenInativacaosCabecalho.splice(j, 1)
            break
          }
        }
      }
      if (this.newItenInativacaosCabecalho.length === 0) {
        this.isDisabledCabecalho = true
      }
    },
    removerItensparaEdicaoAtivacaoCabecalhoExclusao (value) {
      for (let i = 0; i < value.length; i++) {
        // Encontra o índice do objeto a ser removido
        for (let j = 0; j < this.newItenAtivacaoOrientacao.length; j++) {
          if (this.newItenAtivacaoOrientacao[j] === value[i]) {
            this.newItenAtivacaoOrientacao.splice(j, 1)
            break
          }
        }
      }
      if (this.newItenAtivacaoOrientacao.length === 0) {
        this.isDisabledCabecalho = true
      }
    },
    removerItensparaEdicaoExclusaoAssinatura (value) {
      for (let i = 0; i < value.length; i++) {
        // Encontra o índice do objeto a ser removido
        for (let j = 0; j < this.newItensAssinatura.length; j++) {
          if (this.newItensAssinatura[j] === value[i]) {
            if (this.newItensAssinatura.length > 1) {
              this.newItensAssinatura.splice(j, 1)
            } else {
              this.newItensAssinatura = []
            }
            break
          }
        }
      }
    },
    AlterandoNivelPrioridadeAssinatura (value) {
      for (let i = 0; i < value.length; i++) {
        if (this.editarNivelPrioridadeAssinatura !== null && this.editarNivelPrioridadeAssinatura !== undefined && this.editarNivelPrioridadeAssinatura.length > 0) {
          this.editarNivelPrioridadeAssinatura.push(value[i])
        } else {
          this.editarNivelPrioridadeAssinatura[0] = value[i]
        }
      }
    },
    AlterandoNivelPrioridadeCabecalho (value) {
      for (let i = 0; i < value.length; i++) {
        if (this.editarNivelPrioridadeCabecalho !== null && this.editarNivelPrioridadeCabecalho !== undefined && this.editarNivelPrioridadeCabecalho.length > 0) {
          this.editarNivelPrioridadeCabecalho.push(value[i])
        } else {
          this.editarNivelPrioridadeCabecalho[0] = value[i]
        }
      }
    },
    removerItensparaEdicaoExclusaoOrientacao (value) {
      for (let i = 0; i < value.length; i++) {
        // Encontra o índice do objeto a ser removido
        for (let j = 0; j < this.newItensOrientacao.length; j++) {
          if (this.newItensOrientacao[j].OrientacaoId === value[i]) {
            if (this.newItensOrientacao.length > 1) {
              this.newItensOrientacao.splice(j, 1)
            } else {
              this.newItensOrientacao = []
            }
            break
          }
        }
      }
    },
    RemoverEdicaoExcluirPerguntaEquipamento (value) {
      // Encontra o índice do objeto a ser removido
      for (let j = 0; j < this.exclusaoPerguntasEquipamentoPIT.length; j++) {
        if (this.exclusaoPerguntasEquipamentoPIT[j].perguntaId === value.perguntaId) {
          this.exclusaoPerguntasEquipamentoPIT.splice(j, 1)
          break
        }
      }
    },
    limparSalvar () {
      this.newItensCabecalho = {
        Itens: []
      }
      this.newItenAtivacaosCabecalho = []
      this.newItenInativacaosCabecalho = []
      this.novaPerguntaPreRequisitoTemplate = []
      this.editarPerguntaPreRequisitoTemplate = []
      this.excluirPerguntaPreRequisito = []
      this.addEtapaEquipamento = []
      this.novasSubEtapasEquipamentoSemNovasEtapas = []
      this.novaPerguntasEtapasSubEtapaCriada = []
      this.exclusaoPerguntasEquipamentoPIT = []
      this.excluirSubEtapasEtapasEquipamentos = []
      this.editarPerguntaEquipamentoTemplate = []
      this.addEtapaTemplateDetalhes = []
      this.novasSubEtapasTemplateSemNovasEtapas = []
      this.novaPerguntasEtapasSubEtapaCriadaTemplate = []
      this.excluirPerguntaTemplatDetalhe = []
      this.excluirSubEtapasEtapasTemplate = []
      this.editarPerguntaTemplateTemplate = []
      this.perguntasImagensTemplate = []
      this.editarPerguntasImagens = []
      this.newItensAssinatura = []
      this.newItenAtivacaoAssinatura = []
      this.newItenInativacaoAssinatura = []
      this.newItensOrientacao = []
      this.newItenInativacaoOrientacao = []
      this.newItenAtivacaoOrientacao = []
      this.EditaOrientacaoNivelPrioridade = []
      this.editarEtapaTemplateDetalhes = []
      this.editarSubEtapaTemplateDetalhes = []
      this.editarNivelPrioridadeAssinatura = []
      this.editarNivelPrioridadeCabecalho = []
    },
    temEdicoesPendentes () {
      return this.newItensCabecalho.Itens.length > 0 ||
      this.newItensAssinatura.length > 0 ||
      this.newItenAtivacaosCabecalho.length > 0 ||
      this.newItenInativacaosCabecalho.length > 0 ||
      this.newItenAtivacaoAssinatura.length > 0 ||
      this.newItenInativacaoAssinatura.length > 0 ||
      this.newItensOrientacao.length > 0 ||
      this.EditaOrientacaoNivelPrioridade.length > 0 ||
      this.newItenAtivacaoOrientacao.length > 0 ||
      this.newItenInativacaoOrientacao.length > 0 ||
      this.novaPerguntaPreRequisitoTemplate.length > 0 ||
      this.editarPerguntaPreRequisitoTemplate.length > 0 ||
      this.excluirPerguntaPreRequisito.length > 0 ||
      this.addEtapaEquipamento.length > 0 ||
      this.novasSubEtapasEquipamentoSemNovasEtapas.length > 0 ||
      this.novaPerguntasEtapasSubEtapaCriada.length > 0 ||
      this.exclusaoPerguntasEquipamentoPIT.length > 0 ||
      this.excluirSubEtapasEtapasEquipamentos.length > 0 ||
      this.editarPerguntaEquipamentoTemplate.length > 0 ||
      this.addEtapaTemplateDetalhes.length > 0 ||
      this.novasSubEtapasTemplateSemNovasEtapas.length > 0 ||
      this.novaPerguntasEtapasSubEtapaCriadaTemplate.length > 0 ||
      this.excluirPerguntaTemplatDetalhe.length > 0 ||
      this.excluirSubEtapasEtapasTemplate.length > 0 ||
      this.editarPerguntaTemplateTemplate.length > 0 ||
      this.editarEtapaTemplateDetalhes.length > 0 ||
      this.editarSubEtapaTemplateDetalhes.length > 0 ||
      this.editarNivelPrioridadeAssinatura.length > 0 ||
      this.editarNivelPrioridadeCabecalho.length > 0
    },
    validaDados () {
      if (this.temEdicoesPendentes()) {
        this.salvar()
      } else {
        toast.warning('Sem edições para liberação')
      }
    },
    salvar () {
      loading.push()
      this.$refs.tableCabecalho.limparItensEdicao()
      this.$refs.assinatura.limparItensEdicao()
      this.$refs.orientacao.limparItensEdicao()

      let salvarAlteracoes = {
        templateid: this.templateid,
        add: this.newItensCabecalho,
        addAssinatura: this.newItensAssinatura,
        ativacao: this.newItenAtivacaosCabecalho,
        inativacao: this.newItenInativacaosCabecalho.filter(i => !this.exclusoesItemCabecalho.includes(i)),
        ativacaoAssinatura: this.newItenAtivacaoAssinatura,
        inativacaoAssinatura: this.newItenInativacaoAssinatura,
        addOrientacao: this.newItensOrientacao,
        editarNivelPrioridadeOuExcluirOrientacao: this.EditaOrientacaoNivelPrioridade,
        ativacaoOrientacao: this.newItenAtivacaoOrientacao,
        inativacaoOrientacao: this.newItenInativacaoOrientacao,
        novaPergunta: this.novaPerguntaPreRequisitoTemplate,
        editarPergunta: this.editarPerguntaPreRequisitoTemplate,
        excluirPergunta: this.excluirPerguntaPreRequisito,
        novosEquipamentos: this.addEtapaEquipamento,
        novosSubEtapasEquipamentos: this.novasSubEtapasEquipamentoSemNovasEtapas,
        novasPerguntasEquipamentos: this.novaPerguntasEtapasSubEtapaCriada,
        excluirEquipamentos: [],
        excluirSubEtapasEquipamentos: [],
        excluirPerguntasEquipamentos: this.exclusaoPerguntasEquipamentoPIT,
        ExcluirSubEtapaOuEtapaEquipamentos: this.excluirSubEtapasEtapasEquipamentos,
        editarPerguntaEquipamento: this.editarPerguntaEquipamentoTemplate,
        novosItensTemplate: this.addEtapaTemplateDetalhes,
        novosSubEtapasTemplate: this.novasSubEtapasTemplateSemNovasEtapas,
        novasPerguntasTemplate: this.novaPerguntasEtapasSubEtapaCriadaTemplate,
        excluirPerguntaTemplate: this.excluirPerguntaTemplatDetalhe,
        ExcluirSubEtapaOuEtapaTemplate: this.excluirSubEtapasEtapasTemplate,
        EditarPerguntaTemplate: this.editarPerguntaTemplateTemplate,
        EditarEtapa: this.editarEtapaTemplateDetalhes,
        editarSubEtapa: this.editarSubEtapaTemplateDetalhes,
        editarNivelPrioridadeAssinatura: this.editarNivelPrioridadeAssinatura,
        editarNivelPrioridadeCabecalho: this.editarNivelPrioridadeCabecalho,
        exclusoes: this.exclusoesItemCabecalho || []
      }
      qmaTemplate.EdicaoQMATemplate(salvarAlteracoes)
        .then((Response) => {
          loading.pop()

          if (this.perguntasImagensTemplate.length > 0) {
            this.salvarImagensPerguntas(Response.data.result.perguntas)
          }

          if (this.editarPerguntasImagens.length > 0) {
            this.editarImagensPerguntas()
          }

          this.ResultTemplateQMA = Response.data.result
          this.$refs.tableCabecalho.onLoad()
          let atualizaPainel = true

          this.limparSalvar()
          if (this.tipoTemplate === 2) {
            this.$refs.preRequisito.onLoad()
          }
          if (this.tipoTemplate === 1) {
            this.$refs.equipamentoPIT.onLoad(this.templateid)
            this.$refs.equipamentoPIT.voltaParaGrupo()
          }
          if (this.perguntasImagensTemplate.length === 0 && this.editarPerguntasImagens.length === 0) {
            this.$refs.template.onLoad(this.templateid)
            this.$refs.assinatura.onLoad(this.templateid)
            this.$refs.orientacao.onLoad(this.templateid)
          }
          this.$emit('atualizaPainel', atualizaPainel)
          this.$refs.LogQMATemplate.GetLog(this.templateid)
          toast.success('Sucesso na alteração')
        })
        .catch((Error) => {
          loading.pop()
          toast.warning('informações incorretas ao cadastrar')
        })
    },
    salvarImagensPerguntas (value) {
      for (let i = 0; i < value.length; i++) {
        for (let j = 0; j < this.perguntasImagensTemplate.length; j++) {
          for (let k = 0; k < this.perguntasImagensTemplate[j].length; k++) {
            if (this.perguntasImagensTemplate[j][k].temporarioId === value[i].temporarioId) {
              qmaTemplate.uploadImagemPerguntaTemplate(value[i].perguntaCriada.id, this.perguntasImagensTemplate[j][k].descricaoPerguntaSelecaoImagem, this.CompanySelected, this.perguntasImagensTemplate[j][k].file)
                .then((Response) => {
                  this.ResultTemplateQMA = Response.data.result
                  this.$refs.template.onLoad(this.templateid)
                  this.$refs.assinatura.onLoad(this.templateid)
                  toast.success('Sucesso na alteração')
                })
                .catch((Error) => {
                  toast.error('Erro ao cadastrar')
                })
            }
          }
        }
      }
    },
    removerImagemNova (arquivoId) {
      for (let j = 0; j < this.perguntasImagensTemplate.length; j++) {
        for (let k = 0; k < this.perguntasImagensTemplate[j].length; k++) {
          if (this.perguntasImagensTemplate[j][k].arquivoId === arquivoId) {
            this.perguntasImagensTemplate.splice(k, 1)
            k--
            break
          }
        }
      }
    },
    editarImagensPerguntas () {
      for (let j = 0; j < this.editarPerguntasImagens.length; j++) {
        for (let k = 0; k < this.editarPerguntasImagens[j].length; k++) {
          if (this.editarPerguntasImagens[j][k].adicao === true && this.editarPerguntasImagens[j][k].edicao === false) {
            qmaTemplate.uploadImagemPerguntaTemplate(
              this.editarPerguntasImagens[j][k].perguntaId,
              this.editarPerguntasImagens[j][k].descricaoPerguntaSelecaoImagem,
              this.CompanySelected,
              this.editarPerguntasImagens[j][k].file
            )
              .then((Response) => {
                this.ResultTemplateQMA = Response.data.result
                this.$refs.template.onLoad(this.templateid)
                this.$refs.assinatura.onLoad(this.templateid)
                toast.success('Cadastro salvo')
              })
              .catch((Error) => {
                toast.warning('Imagens inválidas')
              })
          }
          if (this.editarPerguntasImagens[j][k].adicao === false && this.editarPerguntasImagens[j][k].edicao === true) {
            qmaTemplate.uploadImagemPerguntaEdicaoTemplate(
              this.editarPerguntasImagens[j][k].perguntaSelecaoImagemId,
              this.editarPerguntasImagens[j][k].descricaoPerguntaSelecaoImagem,
              this.editarPerguntasImagens[j][k].exclusao,
              this.CompanySelected,
              this.editarPerguntasImagens[j][k].file
            )
              .then((Response) => {
                this.ResultTemplateQMA = Response.data.result
                this.$refs.template.onLoad(this.templateid)
                this.$refs.assinatura.onLoad(this.templateid)
                toast.success('Cadastro salvo')
              })
              .catch((Error) => {
                toast.warning('Imagens inválidas')
              })
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/tabsTemplate.js